import { render, staticRenderFns } from "./HelpInfoWrapper.vue?vue&type=template&id=c0121a10"
import script from "./HelpInfoWrapper.vue?vue&type=script&lang=js"
export * from "./HelpInfoWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports